// Simple Vanilla JS version if you prefer not to generate a new Stimulus controller
document.addEventListener('turbo:load', () => {
  const selectAll = document.getElementById('select-all-faqs');
  const checkboxes = document.querySelectorAll('.faq-checkbox');
  const batchActions = document.getElementById('batch-actions');

  const toggleActions = () => {
    const anyChecked = Array.from(checkboxes).some(c => c.checked);
    batchActions.classList.toggle('hidden', !anyChecked);
  };

  selectAll?.addEventListener('change', (e) => {
    checkboxes.forEach(c => c.checked = e.target.checked);
    toggleActions();
  });

  checkboxes.forEach(c => c.addEventListener('change', toggleActions));
});